<ng-container [formGroup]="form">
	<mat-form-field>
		<input
			autocomplete="off"
			matInput
			placeholder="Subdivision Name"
			formControlName="name"
			maxlength="100"
			required
		/>
	</mat-form-field>
	<mat-form-field>
		<mat-label>Status</mat-label>
		<mat-select
			required
			disableOptionCentering="true"
			formControlName="status"
		>
			<mat-option
				*ngFor="let status of subdivisionStatuses"
				[value]="status"
			>
				{{ status }}
			</mat-option>
		</mat-select>
		<mat-error>Required</mat-error>
	</mat-form-field>
</ng-container>
